/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Sc_SettingsInputs */

const en_tut_sc_settings = /** @type {(inputs: Tut_Sc_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to Settings`)
};

const id_tut_sc_settings = /** @type {(inputs: Tut_Sc_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lompat ke Settings`)
};

/**
* | output |
* | --- |
* | "Jump to Settings" |
*
* @param {Tut_Sc_SettingsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_sc_settings = /** @type {((inputs?: Tut_Sc_SettingsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Sc_SettingsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_sc_settings(inputs)
	return en_tut_sc_settings(inputs)
});